import { useEffect, useRef, useState } from "react";
import "./App.css";

export default function App() {
  const showsRef = useRef(null);
  const timerRef = useRef(null);

  const [activeDay, setActiveDay] = useState(0);
  const [daysData, setDaysData] = useState([[], [], []]);
  const [editing, setEditing] = useState(false);

  function buildDay(dayIndex, startTime = "09:00") {
    let arr = [];
    let [h, m] = startTime.split(":").map(Number);

    for (let i = 0; i < 8; i++) {
      const start = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      h += 1;
      const end = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
      arr.push({ start, end });
    }

    setDaysData((prev) => {
      const copy = [...prev];
      copy[dayIndex] = arr;
      return copy;
    });
  }

  function renderShows() {
    const showsEl = showsRef.current;
    const timerEl = timerRef.current;
    if (!showsEl || !timerEl) return;

    showsEl.innerHTML = "";
    const now = new Date();
    let nextShow = null;

    daysData[activeDay]?.forEach((s, idx) => {
      const card = document.createElement("div");
      card.className = "show";

      const input = document.createElement("input");
      input.type = "time";
      input.value = s.start;

      input.style.background = "transparent";
      input.style.border = "none";
      input.style.color = "white";
      input.style.fontSize = "16px";
      input.style.textAlign = "center";

      input.onfocus = () => setEditing(true);
      input.onblur = () => setEditing(false);

      input.onchange = () => {
        const oldValue = s.start; // store previous value

        const pin = prompt(
          "This action is protected. Enter the PIN to modify the time settings",
          "",
        );
        if (pin !== "paka") {
          alert("PIN verification failed. Unable to modify time settings.");
          input.value = oldValue; // revert change
          return;
        }

        // ✅ PIN correct → proceed with your existing logic
        let [hh, mm] = input.value.split(":").map(Number);
        const updated = [...daysData];

        for (let i = idx; i < updated[activeDay].length; i++) {
          const sh = String(hh).padStart(2, "0");
          const sm = String(mm).padStart(2, "0");
          updated[activeDay][i].start = `${sh}:${sm}`;
          hh += 1;
          updated[activeDay][i].end = `${String(hh).padStart(2, "0")}:${sm}`;
        }

        setDaysData(updated);
      };

      const [sh, sm] = s.start.split(":").map(Number);
      const [eh, em] = s.end.split(":").map(Number);

      const st = new Date();
      st.setHours(sh, sm, 0, 0);
      const et = new Date();
      et.setHours(eh, em, 0, 0);

      if (now >= st && now < et) card.classList.add("live");
      else if (now > et) card.classList.add("past");
      else if (!nextShow) nextShow = st;

      card.appendChild(input);
      showsEl.appendChild(card);
    });

    if (nextShow) {
      const diff = Math.max(0, Math.floor((nextShow - now) / 1000));
      const m = Math.floor(diff / 60);
      const s = diff % 60;

      timerEl.innerHTML = `
        <p>
          Next show in (mm:ss)<br>
          <span class="timer-time">${m}:${String(s).padStart(2, "0")}</span>
        </p>`;

      timerEl.style.background =
        m < 10 ? (m < 5 ? "#b91c1c" : "#FFFF00") : "#15803d";
      timerEl.style.color = m < 10 && m >= 5 ? "rgb(15 23 42)" : "white";
      timerEl.style.padding = "8px 16px";
      timerEl.style.borderRadius = "12px";
    } else {
      timerEl.textContent = "No more shows";
      timerEl.style.background = "#b91c1c";
      timerEl.style.padding = "8px 16px";
      timerEl.style.borderRadius = "12px";
    }
  }

  useEffect(() => {
    buildDay(0);
    buildDay(1);
    buildDay(2);
  }, []);

  useEffect(() => {
    renderShows();
  }, [activeDay, daysData]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!editing) renderShows();
    }, 1000);
    return () => clearInterval(interval);
  }, [editing, activeDay, daysData]);

  return (
    <div className="app">
      <div className="top">
        <div className="logo">
          <img src="https://static.wixstatic.com/media/620267_95a67cfaeb8b416da3ce8785dd738a95~mv2.png" />
          <div className="title">LogiMAT 2026 MOPTro Exhibition</div>
        </div>

        <div className="days">
          {["Day 1", "Day 2", "Day 3"].map((d, i) => (
            <div
              key={i}
              className={`day ${activeDay === i ? "active" : ""}`}
              onClick={() => setActiveDay(i)}
            >
              {d}
            </div>
          ))}
        </div>
      </div>

      <div className="content-body">
        <div className="content">
          <div className="timer" id="timer" ref={timerRef}></div>

          <div className="poster-wrapper">
            <div className="poster">
              <img
                src="https://static.wixstatic.com/media/620267_796a265e259843f59a11a20584ed282b~mv2.jpg"
                className="mobile_mode"
              />
              <img
                src="https://static.wixstatic.com/media/620267_67d5126f69e2434ab42dda167a2cc0ac~mv2.jpg"
                className="desktop_mode"
              />
            </div>
          </div>
        </div>

        <div className="shows-wrapper">
          <div className="shows" id="shows" ref={showsRef}></div>
        </div>
      </div>
    </div>
  );
}
